import actionTypes from './action-types';
import memberActionTypes from '../member/action-types';
import { normalize } from './helpers';

export default (state = {}, action) => {
    const requestSearchResults = () => {
        const endpoint = action.payload?.endpoint || null;
        const queryParams = action.payload?.queryParams || state.queryParams;
        return {
            ...state,
            isFetching: true,
            error: null,
            endpoint,
            currentCategoryId:
                queryParams.categoryId || state.currentCategoryId,
            queryParams
        };
    };

    const receiveSearchResults = () => {
        const {
            payload: { result = {}, endpoint = null, queryParams = null }
        } = action;
        return {
            ...state,
            error: null,
            hasResult: true,
            isFetching: false,
            endpoint,
            queryParams,
            ...normalize(result)
        };
    };

    const handleSearchResultsError = () => {
        return {
            ...state,
            error: action.payload,
            hasResult: true,
            isFetching: false,
            ...normalize({})
        };
    };

    const setSingleFilter = () => ({
        ...state,
        filters: {
            ...state.filters,
            [action.payload.filter]: {
                ...state.filters[action.payload.filter],
                selectedValue: action.payload.value
            }
        }
    });

    const addItemOnDisplay = () => {
        const { payload } = action;
        return {
            ...state,
            itemsOnDisplayById: state.itemsOnDisplayById.includes(
                payload.itemId
            )
                ? [...state.itemsOnDisplayById]
                : [...state.itemsOnDisplayById, payload.itemId]
        };
    };

    const removeItemOnDisplay = () => {
        const { payload } = action;
        const items = state.itemsOnDisplayById.filter(
            item => item !== payload.itemId
        );
        return {
            ...state,
            itemsOnDisplayById: [...items]
        };
    };

    const setCategoryPath = () => {
        return {
            ...state,
            categoryPath: action.payload,
            currentCategoryId: (action.payload && action.payload[0].id) || 0
        };
    };

    const setCurrentCategoryId = () => {
        return {
            ...state,
            currentCategoryId: action.payload
        };
    };

    // Set show/hide buyer region filter when member geo changes
    const showOrHideAllowedBuyerRegionFilter = () => {
        const { payload } = action;
        return {
            ...state,
            displayAllowedBuyerRegionFilter:
                state.displayAllowedBuyerRegionFilter ||
                payload?.isoCode !== 'SE'
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.REQUEST_SEARCH_RESULTS]: requestSearchResults,
        [actionTypes.RECEIVE_SEARCH_RESULTS]: receiveSearchResults,
        [actionTypes.HANDLE_SEARCH_RESULTS_ERROR]: handleSearchResultsError,
        [actionTypes.SET_SINGLE_FILTER]: setSingleFilter,
        [actionTypes.ADD_ITEM_ON_DISPLAY]: addItemOnDisplay,
        [actionTypes.REMOVE_ITEM_ON_DISPLAY]: removeItemOnDisplay,
        [actionTypes.SET_CATEGORY_PATH]: setCategoryPath,
        [actionTypes.SET_CURRENT_CATEGORY_ID]: setCurrentCategoryId,
        [memberActionTypes.SET_GEOLOCATION]: showOrHideAllowedBuyerRegionFilter
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
